export const placeholder_url = "https://placehold.co/100x100/png";

export const page_size = {
    "mug": "300x200",
    "t-shirt": "800x1000",
    "landscape": "353x250",
    "portait": "340x481",
    "key-chain": "150x200",
    "card": "340x481"
}


export const single_photo = {
    "count": 1,
    "photos": [{
        "url": placeholder_url,
        "x": 100,
        "y": 200,
        "width": 100,
        "height": 100,
    }]
}


export const quad_photos = {
    "count": 4,
    "photos": [{
            "url": placeholder_url,
            "x": 125,
            "y": 125,
            "width": 100,
            "height": 100
        },
        {
            "url": placeholder_url,
            "x": 375,
            "y": 125,
            "width": 100,
            "height": 100
        },
        {
            "url": placeholder_url,
            "x": 125,
            "y": 375,
            "width": 100,
            "height": 100
        },
        {
            "url": placeholder_url,
            "x": 375,
            "y": 375,
            "width": 100,
            "height": 100
        },
    ]
}

export const stickerConfigurations = {
    birthday: [
        'https://ec-i.s3.eu-west-2.amazonaws.com/birthday-limited-edition.png',
        'https://ec-i.s3.eu-west-2.amazonaws.com/cake.png',
        'https://ec-i.s3.eu-west-2.amazonaws.com/KISS.png',

        // You can add more sticker URLs here
    ],
    valentines: [
        'https://ec-i.s3.eu-west-2.amazonaws.com/i/stickers/heart.png',
        'https://ec-i.s3.eu-west-2.amazonaws.com/i/stickers/lips.png',
   
    ],
    christmas: [
        'https://ec-i.s3.eu-west-2.amazonaws.com/santa.png',
        'https://ec-i.s3.eu-west-2.amazonaws.com/christmas+tree.png',
        'https://ec-i.s3.eu-west-2.amazonaws.com/raindeer.png',
        'https://ec-i.s3.eu-west-2.amazonaws.com/snowflake.png',
        'https://ec-i.s3.eu-west-2.amazonaws.com/holly.png'
    ],
    new_year: [
        'https://placeholder.com/firework.png',
        'https://placeholder.com/2024-glasses.png',
        'https://placeholder.com/newyear-clock.png',
    ],
    halloween: [
        'https://placeholder.com/pumpkin.png',
        'https://placeholder.com/ghost.png',
        'https://placeholder.com/witch-hat.png',
    ],
    anniversary: [
        'https://placeholder.com/anniversary-bells.png',
        'https://placeholder.com/anniversary-cake.png',
        'https://placeholder.com/anniversary-gift.png',
    ],
    thanksgiving: [
        'https://placeholder.com/turkey.png',
        'https://placeholder.com/pie.png',
        'https://placeholder.com/thanksgiving-hat.png',
    ],
    graduation: [
        'https://placeholder.com/cap.png',
        'https://placeholder.com/diploma.png',
        'https://placeholder.com/graduation-photo.png',
    ],
    easter: [
        'https://placeholder.com/easter-egg.png',
        'https://placeholder.com/easter-bunny.png',
        'https://placeholder.com/easter-basket.png',
    ],
    mothers_day: [
        'https://ec-i.s3.eu-west-2.amazonaws.com/stickers/flowers_sticker.png',
        'https://ec-i.s3.eu-west-2.amazonaws.com/stickers/heart_sticker.png'
    
    ],
    fathers_day: [
        'https://placeholder.com/fathers-day-tie.png',
        'https://placeholder.com/fathers-day-hat.png',
        'https://placeholder.com/fathers-day-gift.png',
    ],
    wedding: [
        'https://placeholder.com/wedding-ring.png',
        'https://placeholder.com/wedding-dress.png',
        'https://placeholder.com/wedding-invite.png',
    ],
    baby_shower: [
        'https://placeholder.com/baby-booties.png',
        'https://placeholder.com/baby-bottle.png',
        'https://placeholder.com/baby-onesie.png',
    ],
    get_well_soon: [
        'https://placeholder.com/thermometer.png',
        'https://placeholder.com/medicine.png',
        'https://placeholder.com/get-well-card.png',
    ],
    sympathy: [
        'https://placeholder.com/condolences-card.png',
        'https://placeholder.com/white-rose.png',
        'https://placeholder.com/candle.png',
    ],
    congratulations: [
        'https://placeholder.com/trophy.png',
        'https://placeholder.com/ribbon.png',
        'https://placeholder.com/congrats-card.png',
    ],
    retirement: [
        'https://placeholder.com/rocking-chair.png',
        'https://placeholder.com/retirement-clock.png',
        'https://placeholder.com/retirement-card.png',
    ]
}

    // Function to get frames based on themex
    function getFramesForTheme(theme) {
        if (theme === 'default') {
            return [
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/1.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/2.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/3.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/4.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/5.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/6.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/7.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/8.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/9.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/10.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/11.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/12.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/13.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/14.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/15.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/16.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/17.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/18.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/19.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/20.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/21.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/22.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/23.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/24.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/25.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/26.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/27.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/28.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/29.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/30.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/31.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/32.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/33.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/34.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/35.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/36.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/37.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/38.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/39.png",
                "https://res.cloudinary.com/dtvulqdly/image/fetch/f_auto,q_auto,w_300/https://ec-i.s3.eu-west-2.amazonaws.com/frames/40.png"
            ];
        }
     
}


export const productConfigurations = {
    card_happy_valentines_day1: {
        front_cover: {
            print_type: "a4_card_portrait",
            ai_background: true,
            user_video: {
                        "url": '', // URL of the user's video
                       "x": 50,
                      "y": 100,
                       "width": 200,
                      "height": 150,
        
                   },
          
            type: 'card',
            page_size: page_size['card'],
            frames: getFramesForTheme('default'), 
            background: "#c95f54",

            text: [
                { }
            ],
            name: {
                value: 'Enter Name',
                x: 170,
                y: 315,
                font: 'Amatic SC',
                color: "#fff", 
                anchor: "middle",
                size: 35,
                weight: 800
            },  
            image: [
                {
                    "id": "imageElement0",
                    "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/hvd1.png",
                    "x": 0,
                    "y": 0,                   
                    "r": null,
                    "w": 341,
                    "h": 481,
                    "rotation": 0
                  }
            ],
            stickers: 'valentines'
        },
        inside_left: {
            
            ai_background: true,
            type: 'card',
            page_size: page_size['card'],
            stickers: 'birthday', 
            background: '#d2ebea',
            text: {
                value: 'Inner Left Text',
                x: 100,
                y: 230
            }
        },
        inside_right: {
            ai_background: true,
            type: 'card',
            page_size: page_size['card'],
            background: '#d2ebea',
            text: [{
                message_card: true,
                edit: true,
                value: 'Message Card',
                x: 20,
                y: 270,
                font: "Reenie Beanie",
                size: 20,
                color: "#643532",
                anchor: "start",
                maxWidth: 250,
                maxHeight: 200 
            }]
        },
        feature_3d: {
            type: 'card',
            mode: 'card',
            page_size: page_size['card']
        }
    }
,
card_happy_valentines_day5: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#c95f54",

        text: [
            { }
        ],
        name: {
            "value": "Enter Name",
            "x": 165,
            "y": 200,
            "font": "Great Vibes", // Changed to a romantic Google Web Font
            "color": "#fff", 
            "anchor": "middle",
            "size": 60,
            "weight": 800,
            "r": -20
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/hvd5.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
        stickers: 'valentines'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,card_happy_valentines_day6: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#ba0028",
        user_photo: [{
            id: 'user-photo-1',
            url: 'https://ec-i.s3.eu-west-2.amazonaws.com/i/placeholders/smiling_couple_342.jpg',
            x: 0,
            y: 50,
            width: 342,
            height: 315,
            shape: 'heart'
        }
        //    
    
    ],
    text: [
        {
            "value": "Happy Valentine's Day",
            "x": 170, // X-position of the text
            "y": 385, // Y-position of the text, below the heart image
            "font": "Great Vibes", // Romantic Google Web Font
            "color": "#fff", // Text color
            "anchor": "middle", // Center the text
            "size": 30, // Text size
            "weight": 800, // Text weight
            "r": 0 // Text rotation
        }
    ],
    name: {
        "value": "Enter Name",
        "x": 170, // X-position of the name
        "y": 0, // Y-position of the name, below the "Happy Valentine's Day" text
        "font": "Great Vibes", // Romantic Google Web Font
        "color": "#fff", // Text color
        "anchor": "middle", // Center the text
        "size": 30, // Smaller size for the name
        "weight": 800, // Text weight
        "r": 0 // Text rotation
    },
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/hvd6.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
        stickers: 'valentines'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,
card_happy_valentines_day2: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#c95f54",

        text: [
            { }
        ],
        name: {
            value: 'Enter Name',
            x: 170,
            y: 240,
            font: 'PT Sans',
            color: "#fff", 
            anchor: "middle",
            size: 30,
            weight: 800
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/hvd2.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
        stickers: 'valentines'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,
card_happy_valentines_day3: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#c95f54",

        text: [
            {
                edit: false,
                value: "Happy",
                x: 170,
                y: 157,
                font: "Caveat",
                size: 60,
                color: "#fff",
                anchor: "middle",
                weight: 700
            },
            {
                edit: false,
                value: "Valentine's Day",
                x: 165,
                y: 230,
                font: "Caveat",
                size: 60,
                color: "#fff",
                anchor: "middle",
                weight: 700
            }
        ],
        name: {
            value: 'Enter Name',
            x: 170,
            y: 250, // Adjusted y to place the name underneath "Valentine's Day"
            font: 'Caveat',
            color: "#fff",
            anchor: "middle",
            size: 30,
            weight: 800
        },
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/hvd3.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
        stickers: 'valentines'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
},

card_happy_valentines_day4: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#c95f54",

        "text": [
            {
                "edit": false,
                "value": "I Met You",
                "x": 170,
                "y": 170,
                "font": "Pacifico",
                "size": 30,
                "color": "#fff",
                "anchor": "middle",
                "weight": 400,
                "shadow": {
                    "offsetX": 2,
                    "offsetY": 2,
                    "blurRadius": 3,
                    "color": "#000"
                }
            },
            {
                "edit": false,
                "value": "I Liked You",
                "x": 170,
                "y": 210,
                "font": "Pacifico",
                "size": 30,
                "color": "#fff",
                "anchor": "middle",
                "weight": 400,
                "shadow": {
                    "offsetX": 2,
                    "offsetY": 2,
                    "blurRadius": 3,
                    "color": "#000"
                }
            },
            {
                "edit": false,
                "value": "I Loved You",
                "x": 170,
                "y": 250,
                "font": "Pacifico",
                "size": 30,
                "color": "#fff",
                "anchor": "middle",
                "weight": 400,
                "shadow": {
                    "offsetX": 2,
                    "offsetY": 2,
                    "blurRadius": 3,
                    "color": "#000"
                }
            },
            {
                "edit": false,
                "value": "I’m Keeping You",
                "x": 170,
                "y": 290,
                "font": "Pacifico",
                "size": 30,
                "color": "#fff",
                "anchor": "middle",
                "weight": 400,
                "shadow": {
                    "offsetX": 2,
                    "offsetY": 2,
                    "blurRadius": 3,
                    "color": "#000"
                }
            }
        ],
        name: {
        },
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/hvd4.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
        stickers: 'valentines'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
},
    card_happy_valentines_day: {
        front_cover: {
            print_type: "a4_card_portrait",
            ai_background: true,
            user_video: {
                        "url": '', // URL of the user's video
                       "x": 50,
                      "y": 100,
                       "width": 200,
                      "height": 150,
        
                   },
          
            type: 'card',
            page_size: page_size['card'],
            frames: getFramesForTheme('default'), 
            background: "#c95f54",

            text: [
                { }
            ],
            name: {
                value: 'Enter Name',
                x: 170,
                y: 360,
                font: 'Amatic SC',
                color: "#fff", 
                anchor: "middle",
                size: 50,
                weight: 400
            },  
            image: [
                {
                    "id": "imageElement0",
                    "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/hvd.png",
                    "x": 0,
                    "y": 157,                   
                    "r": null,
                    "w": 341,
                    "h": 194,
                    "rotation": 0
                  }
            ],
            stickers: 'valentines'
        },
        inside_left: {
            
            ai_background: true,
            type: 'card',
            page_size: page_size['card'],
            stickers: 'birthday', 
            background: '#d2ebea',
            text: {
                value: 'Inner Left Text',
                x: 100,
                y: 230
            }
        },
        inside_right: {
            ai_background: true,
            type: 'card',
            page_size: page_size['card'],
            background: '#d2ebea',
            text: [{
                message_card: true,
                edit: true,
                value: 'Message Card',
                x: 20,
                y: 270,
                font: "Reenie Beanie",
                size: 20,
                color: "#643532",
                anchor: "start",
                maxWidth: 250,
                maxHeight: 200 
            }]
        },
        feature_3d: {
            type: 'card',
            mode: 'card',
            page_size: page_size['card']
        }
    }
,


/* Mothers Day */

card_number_1_fan: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#f7a7a1",

        text: [
            { }
        ],
        name: {
           
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/number_1_fan_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
        user_photo: [
            {
                id: "photo1",
                image_transformation: 'remove_background',
                url: 'https://ec-i.s3.eu-west-2.amazonaws.com/i/placeholders/young_girl.png',
                y: 250, 
                x: 30,
                width: 182, 
                height: 196,
                r: 0,
                text: "Click to Upload Your Photo"
            }
        ],
        
        stickers: 'mothers_day'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'mothers_day', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,


card_best_mum_ever: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#FFDAD9",

        text: [
            { }
        ],
        name: {
           
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/best_mum_ever_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
       
        
        stickers: 'mothers_day'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'mothers_day', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,




card_to_the_best_mum: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#E6A8CE",

        text: [
            { }
        ],
        name: {
           
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/to_the_best_mum_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
        user_photo: [{
            id: 'user-photo-1',
            url: 'https://ec-i.s3.eu-west-2.amazonaws.com/i/placeholders/child_with_mum.png', 
            x: 0,
            y: 170,
            width: 342,
            height: 315,
            shape: 'heart',
            text: "Click to Upload Your Photo"
     } ],
       
        
        stickers: 'mothers_day'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'mothers_day', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,

card_undercover_super_hero_mum: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#FF57D7",

        text: [
            { }
        ],
        name: {
           
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/undercover-super-hero-mum_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
       
       
        
        stickers: 'mothers_day'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'mothers_day', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,

card_happy_mothers_day_from: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#fff",

        text: [
            {
                edit: true,
                "value": "All My Love",
                "x": 160, // X-position of the text
                "y": 80, // Y-position of the text, below the heart image
                "font": "Damion", // Romantic Google Web Font
                "color": "#6D254F", // Text color
                "anchor": "middle", // Center the text
                "size": 20, // Text size
                "weight": 800, // Text weight
                "r": 0 // Text rotation
            },{
                edit: true,
            "value": "Your Name",
            "x": 170, // X-position of the name
            "y": 420, // Y-position of the name, below the "Happy Valentine's Day" text
            "font": "Damion", // Romantic Google Web Font
            "color": "#fff", // Text color
            "anchor": "middle", // Center the text
            "size": 40, // Smaller size for the name
            "weight": 400, // Text weight
            "r": 0 // Text rotation
            }
        ],
        name: {
        }, 
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/happy_mothers_day_from_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
       
       
        
        stickers: 'mothers_day'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'mothers_day', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,


card_thanks_mum_i_turned_out_alright: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#fff",

        text: [
            {
                
            }
        ],
        name: {
        }, 
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/thanks_mum_i_turned_out_alright_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
       
       
        
        stickers: 'mothers_day'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'mothers_day', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,



card_happy_mothers_day_soon_to_be_mama: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#fff",

        text: [
            {
                
            }
        ],
        name: {
        }, 
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/happy_mothers_day_soon_to_be_mama_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
       
       
        
        stickers: 'mothers_day'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'mothers_day', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,


card_thanks_a_bunch: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#FAD9F3",

        text: [
            {
                
            }
        ],
        name: {
        }, 
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/thanks_a_bunch_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
       
       
        
        stickers: 'mothers_day'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'mothers_day', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,


card_thank_you_for_everything_mum: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#FF99D0",

        text: [
            {
                
            }
        ],
        name: {
        }, 
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/thank_you_for_everything_mum_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
        user_photo: [{
            id: 'user-photo-1',
            url: 'https://ec-i.s3.eu-west-2.amazonaws.com/placeholders/mother_daughter.png',
            x: 10,
            y: 110,
            width: 342,
            height: 315,
            shape: 'circle',
            shape_colour: "#FF6C8C",
            image_transformation: 'remove_background',
            text: "Click to Upload Your Photo"
         
        }],
       
        
        stickers: 'mothers_day'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,




card_nothing_wihout_you_mum: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#fbf0cc",

        text: [
            {
                
            }
        ],
        name: {
        }, 
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/nothing_without_you_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
       
       
        
        stickers: 'mothers_day'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,


card_mothers_day: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#fff",

        text: [
            {
                
            }
        ],
        name: {
        }, 
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/mothers_day.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0
              }
        ],
       
       
        
        stickers: 'mothers_day'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,



card_mum_of_the_year_award: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#fff",

        text: [
            {
                
            }
        ],
        name: {
        }, 
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/mum_of_the_year_award_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
               
              }
        ],
        user_photo: [{
            id: 'user-photo-1',
            url: 'https://ec-i.s3.eu-west-2.amazonaws.com/i/placeholders/elderly_woman_smiling.png',
            x: 10,
            y: 10,
            width: 220,
            height: 455,
            text: "Click to Upload Your Photo"
        }],
       
        
        stickers: 'mothers_day'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,







    card_christmas: {
        front_cover: {
            print_type: "a4_card_portrait",
            ai_background: true,
            type: 'card',
            page_size: page_size['card'],
            frames: getFramesForTheme('default'), 
            background: '#307a00',
            text: [
                {
                    edit: false,
                    value: "Merry",
                    x: 170, 
                    y: 220,
                    font: "Dancing Script", 
                    size: 60,
                    color: "#fff", 
                    anchor: "middle",
                    weight: 800
                },
                {
                    edit: false,
                    value: "Christmas",
                    x: 170,
                    y: 270, 
                    font: "Dancing Script",
                    size: 70,
                    color: "#fff", 
                    anchor: "middle",
                    weight: 800
                }
            ],
            name: {
                value: 'Enter Name',
                x: 170,
                y: 330,
                font: 'Amatic SC',
                color: "#fff", 
                anchor: "middle",
                size: 35,
                weight: 400
            },
            image: [
                {
                    url: 'https://ec-i.s3.eu-west-2.amazonaws.com/christmas_green.png',
                    y: 0, 
                    x: 0,
                    w: 340, 
                    h: 481,
                    r: 0 
                }
            ],
            stickers: 'christmas'
        },
        inside_left: {
            
            ai_background: true,
            type: 'card',
            page_size: page_size['card'],
            stickers: 'birthday', 
            background: '#d2ebea',
            text: {
                value: 'Inner Left Text',
                x: 100,
                y: 230
            }
        },
        inside_right: {
            ai_background: true,
            type: 'card',
            page_size: page_size['card'],
            background: '#d2ebea',
            text: [{
                message_card: true,
                edit: true,
                value: 'Message Card',
                x: 20,
                y: 270,
                font: "Reenie Beanie",
                size: 20,
                color: "#643532",
                anchor: "start",
                maxWidth: 250,
                maxHeight: 200 
            }]
        },
        feature_3d: {
            type: 'card',
            mode: 'card',
            page_size: page_size['card']
        }
    }
,

//AI
//Acrylic
acrylic_landscape_colorise: {
    front_cover: {
        print_type: "a4_acrylic_landsacape",
   //    ai_background: false,

        type: 'acrylic',
        medium_effect:'acrylic_print',
        transparent:false,
        page_size: page_size['landscape'],

       
        background: '#fff',
        
        user_photo: [
            {
                id: "fullsize",
                image_transformation: 'image_restore',
                url: 'https://ec-i.s3.eu-west-2.amazonaws.com/i/placeholders/couple_landscape_colloseum.jpg',
                y: 0, 
                x: 0,
                width: 353, 
                height: 250,
                r: 0,
                text: "Click and Upload Your Black & White Photo"
            }
        ],
       stickers: 'valentines'
    },
    feature_3d: {
        type: 'acrylic',
        mode: 'card',
        page_size: page_size['card']
    }
},

//Acrylic
acrylic_landscape: {
    front_cover: {
        print_type: "a4_acrylic_landsacape",
   //    ai_background: false,

        type: 'acrylic',
        medium_effect:'acrylic_print',
        transparent:false,
        page_size: page_size['landscape'],

       
        background: '#fff',
        
        user_photo: [
            {
                id: "fullsize",
                url: 'https://ec-i.s3.eu-west-2.amazonaws.com/i/placeholders/couple_landscape_colloseum.jpg',
                y: 0, 
                x: 0,
                width: 353, 
                height: 250,
                r: 0 
            }
        ],
       stickers: 'valentines'
    },
    feature_3d: {
        type: 'acrylic',
        mode: 'card',
        page_size: page_size['card']
    }
},

acrylic_portrait: {
    front_cover: {
        print_type: "a4_acrylic_portrait",
   //    ai_background: false,

        type: 'acrylic',
        medium_effect:'acrylic_print',
        transparent:false,
        page_size: page_size['portait'],

       
        background: '#fff',        
        user_photo: [
            {
                id: "fullsize",
                url: 'https://ec-i.s3.eu-west-2.amazonaws.com/i/placeholders/placeholder_elderly-couple.jpg',
                y: 0, 
                x: 0,
                width: 340, 
                height: 481,
                r: 0 
            }
        ],
       stickers: 'valentines'
    },
    feature_3d: {
        type: 'acrylic',
        mode: 'card',
        page_size: page_size['card']
    }
},


//Acrylic
acrylic_music: {
    front_cover: {
        print_type: "a4_acrylic_portrait",
   //    ai_background: false,

        type: 'acrylic',
        medium_effect:'acrylic',
        transparent:true,
        page_size: page_size['card'],

       
        background: '#fff',
        spotify: [{
            id: 'user-photo-1',
            url: '',
            x: 0,
            y: 0,
            width: 100,
            height: 100,
            artist:'Select Artist',
            track:'Select Track', 
            album: 'Select Album' 

        }],
       
        user_photo: [
            {
                id: "music_photo",
                url: 'https://ec-i.s3.eu-west-2.amazonaws.com/i/smiling_couple_square.jpg',
                y: 39, 
                x: 46,
                width: 241, 
                height: 240,
                r: 0 
            }
        ],
        text: [
            {
                id: "music_artist",
                edit: true,
                value: "Artist",
                x: 160, 
                y: 327,
                font: "Amatic SC", 
                size: 20,
                color: "#000", 
                anchor: "middle",
                weight: 400
            },
            {
                id: "music_song",
                edit: true,
                value: "Song",
                x: 160,
                y: 300, 
                font: "Amatic SC",
                size: 26,
                color: "#000", 
                anchor: "middle",
                weight: 800
            },
            {
                id: "music_duration",
                edit: false,
                value: "-3:57",
                x: 289,
                y: 365, 
                font: "Amatic SC",
                size: 12,
                color: "#000", 
                anchor: "middle",
                weight: 800
            },
            {
                id: "music_starttime",
                edit: false,
                value: "-:38",
                x: 40,
                y: 365, 
                font: "Amatic SC",
                size: 12,
                color: "#000", 
                anchor: "middle",
                weight: 800
            }
        ],
        name: {
            value: 'Enter Name',
            x: 170,
            y: -3,
            font: 'Amatic SC',
            color: "#000", 
            anchor: "middle",
            size: 22,
            weight: 400
        },
        image: [
            {
                id: "imageElement0",
                url: 'https://ec-i.s3.eu-west-2.amazonaws.com/i/play_buttons.png',
                y: 317, 
                x: 33,
                w: 265, 
                h: 110,
                r: 0 
            },
            {
                id: "music_qr",
                url: 'https://placehold.co/100x100',
                y: 437, 
                x: 0,
                w: 54, 
                h: 37,
                r: 0 
            },
            {
                id: "waveform",
                url: 'https://ec-i.s3.eu-west-2.amazonaws.com/i/waveform.png',
                y: 437, 
                x: 65,
                w: 200, 
                h: 30,
                r: 0 
            },
       
        ],
       // stickers: 'christmas'
    },
    feature_3d: {
        type: 'acrylic',
        mode: 'card',
        page_size: page_size['card']
    }
},





//BIRTHDAY



card_lets_party_happy_birthday: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#FFDB45",

        text: [
            {
                edit: false,
                value: "Happy Birthday",
                x: 170,
                y: 390,
                font: "Jacques Francois Shadow",
                size: 35,
                color: "#FF365D",
                anchor: "middle",
                weight: 700
            }
        ],
        name: {
            value: 'Enter Name',
            x: 170,
            y: 410, 
            font: 'Jacques Francois Shadow',
            color: "#FF365D",
            anchor: "middle",
            size: 35,
            weight: 800
        },
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/lets_party_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
               
              }
        ],
        user_photo: [{
        }],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,

card_hb_butter_flies_age: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#F2E9D9",
        "text": [
            {
                "edit": false,
                "value": "Happy",
                "x": 170, // Centered horizontally
                "y": 170,  // Updated to correctly center and space the elements
                "font": "Lilita One",
                "size": 60,
                "color": "#FE270D",
                "anchor": "middle",
                "weight": 300
            },
            {
                "edit": true,
                "value": "8th",
                "x": 170, // Centered horizontally
                "y": 260, // Updated to correctly center and space the elements
                "font": "Lilita One",
                "size": 100,
                "color": "#16699F",
                "anchor": "middle",
                "weight": 300
            },
            {
                "edit": false,
                "value": "Birthday",
                "x": 170, // Centered horizontally
                "y": 320, // Updated to correctly center and space the elements
                "font": "Lilita One",
                "size": 60,
                "color": "#FE270D",
                "anchor": "middle",
                "weight": 300
            }
        ],
        "name": {
            "value": "Enter Name",
            "x": 170, // Centered horizontally
            "y": 335, // Updated to correctly center and space the elements
            "font": "Lilita One",
            "color": "#FB8E00",
            "anchor": "middle",
            "size": 30,
            "weight": 300
        },
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/hb_butter_flies_age_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
               
              }
        ],
        user_photo: [{
        }],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,

card_woo_hoo_its_your_birthday: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#F2E9D9",
        "text": [
        ],
        "name": {
        },
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/woo_hoo_its_your_birthday_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
               
              }
        ],
        user_photo: [{
        }],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,


card_hb_you_party_animal: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#FAEAE0",
        "text": [
            {
                "edit": true,
                "value": "Happy Birthday",
                "x": 170, // Centered horizontally
                "y": 360,  // Updated to correctly center and space the elements
                "font": "Truculenta",
                "size": 40,
                "color": "#fd0b70",
                "anchor": "middle",
                "weight": 600
            },
            {
                "edit": true,
                "value": "You Party Animal!",
                "x": 170, // Centered horizontally
                "y": 400, // Updated to correctly center and space the elements
                "font": "Truculenta",
                "size": 30,
                "color": "#fd0b70",
                "anchor": "middle",
                "weight": 300
            },
           
        ],
        "name": {
        },
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/hb_you_party_animal_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
               
              }
        ],
        user_photo: [{
        }],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,



card_hb_to_you: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#a29372",
        "text": [
            {
                "edit": false,
                "value": "Happy Birthday",
                "x": 170, // Centered horizontally
                "y": 340,  // Updated to correctly center and space the elements
                "font": "Truculenta",
                "size": 40,
                "color": "#2c3652",
                "anchor": "middle",
                "weight": 600
            },
            {
                "edit": true,
                "value": "Wishing you a wild and wonderful birthday ",
                "x": 170, // Centered horizontally
                "y": 370, // Updated to correctly center and space the elements
                "font": "Truculenta",
                "size": 13,
                "color": "#2c3652",
                "anchor": "middle",
                "weight": 300
            }, {
                "edit": true,
                "value": " filled with love, laughter and surprises",
                "x": 170, // Centered horizontally
                "y": 385, // Updated to correctly center and space the elements
                "font": "Truculenta",
                "size": 13,
                "color": "#2c3652",
                "anchor": "middle",
                "weight": 300
            },
      
        ],
        name: {
            value: 'Enter Name',
            x: 170,
            y: 75,
            font: 'Amatic SC',
            color: "#2c3652", 
            anchor: "middle",
            size: 13,
            weight: 800
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/hb_to_you_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
          
              }
        ],
        user_photo: [{
            id: 'user-photo-1',
            url: 'https://ec-i.s3.eu-west-2.amazonaws.com/placeholders/boy.jpg',
            x: 95,
            y: 115,
            width: 150,
            height: 180,
            image_transformation: 'remove_background',
            text: "Click to Upload Your Photo",
           
         
        }],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,


card_keeping_it_real_since: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        //frames: getFramesForTheme('default'), 
        background: "#F1AD21",
        "text": [
            {
                "edit": true,
                "value": "1964",
                "x": 180, // Centered horizontally
                "y": 310,  // Updated to correctly center and space the elements
                "font": "Truculenta",
                "size": 82,
                "color": "#fff",
                "anchor": "right",
                "weight": 800
            },
            
      
        ],
        name: {
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/keeping_it_real_since_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
               
              }
        ],
        user_photo: [],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,




card_birthday_toast: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        //frames: getFramesForTheme('default'), 
        background: "#fdd462",
        "text": [
            
      
        ],
        name: {
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/birthday_toast_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
               
              }
        ],
        user_photo: [],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,




card_happea_birthday: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        //frames: getFramesForTheme('default'), 
        background: "#E8E65D",
        "text": [
            
      
        ],
        name: {
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/happea_birthday_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
               
              }
        ],
        user_photo: [],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,



card_birthday_square: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#FFD61A",
        "text": [
            {
                "edit": false,
                "value": "Happy",
                "x": 170, // Centered horizontally
                "y": 25,  // Updated to correctly center and space the elements
                "font": "Lexend Deca",
                "size": 30,
                "color": "#1F1F1F",
                "anchor": "middle",
                "weight": 600
            },
         
      
        ],
        name: {
            value: 'Enter Name',
            x: 170,
            y: 420,
            font: 'Lexend Deca',
            color: "#1F1F1F", 
            anchor: "middle",
            size: 30,
            weight: 800
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/birthday_square_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
               index:1
              }
        ],
        user_photo: [{
            id: 'user-photo-1',
            url: 'https://ec-i.s3.eu-west-2.amazonaws.com/placeholders/boy.jpg',
            x: 220,
            y: 180,
            width: 98,
            height: 121,
            image_transformation: 'remove_background',
            text: "Upload Your Photo",
            index:0
         
        }],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,




card_birthday_pineapple: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#333536",
        "text": [
            {
                "edit": false,
                "value": "Happy",
                "x": 170, // Centered horizontally
                "y": 200,  // Updated to correctly center and space the elements
                "font": "Jacques Francois Shadow",
                "size": 40,
                "color": "#fff",
                "anchor": "middle",
                "weight": 300
            },
            {
                "edit": false,
                "value": "Birthday",
                "x": 170, // Centered horizontally
                "y": 240,  // Updated to correctly center and space the elements
                "font": "Jacques Francois Shadow",
                "size": 40,
                "color": "#fff",
                "anchor": "middle",
                "weight": 300
            },
         
         
      
        ],
        name: {
            value: 'Enter Name',
            x: 170,
            y: 260,
            font: 'Jacques Francois',
            color: "#fff", 
            anchor: "middle",
            size: 30,
            weight: 600
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/birthday_pineapple_bg.jpg",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
               index:1
              }
        ],
        user_photo: [],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,




card_happy_birthday_frame: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#FFD61A",
        "text": [
         
      
        ],
        name: {
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/happy_birthday_frame_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
               index:1
              }
        ],
        user_photo: [{
            id: 'user-photo-1',
            url: 'https://ec-i.s3.eu-west-2.amazonaws.com/placeholders/boy.jpg',
            x: 88,
            y: 110,
            width: 166,
            height: 270,
            
            text: "Upload Your Photo",
            index:0
         
        }],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,




card_out_of_this_world: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#a29372",
        "text": [
            {
                "edit": false,
                "value": "Happy Birthday",
                "x": 170, // Centered horizontally
                "y": 50,  // Updated to correctly center and space the elements
                "font": "Truculenta",
                "size": 40,
                "color": "#fff",
                "anchor": "middle",
                "weight": 600
            }
      
        ],
        name: {
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/out_of_this_world_bg.jpg",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
          
              }
        ],
        user_photo: [{
            id: 'user-photo-1',
            url: 'https://ec-i.s3.eu-west-2.amazonaws.com/placeholders/boy.jpg',
            x: 20,
            y: 95,
            width: 300,
            height: 300,
            image_transformation: 'style_in_space',
            text: "Click to Upload Your Photo",
           
         
        }],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,



card_purr_fect_birthday: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#FFE184",
        "text": [
      
        ],
        name: {
        },  
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/purr_fect_birthday_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
          
              }
        ],
        user_photo: [{
            id: 'user-photo-1',
            url: 'https://ec-i.s3.eu-west-2.amazonaws.com/placeholders/boy.jpg',
            x: 180,
            y: 217,
            width: 126,
            height: 205,
            image_transformation: 'remove_background',
            text: "Click to Upload Your Photo",
           
         
        }],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,


card_happy_birthday_swirls: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#FFE184",
        "text": [
            {
                "edit": true,
                "value": "Have an Awesome Birthday",
                "x": 170, // Centered horizontally
                "y": 430,  // Updated to correctly center and space the elements
                "font": "Rock Salt",
                "size": 14,
                "color": "#fff",
                "anchor": "middle",
                "weight": 300
            },
           
      
        ],
        name: {
            value: 'Enter Name',
            x: 165,
            y: 7,
            font: 'Rock Salt',
            color: "#000", 
            anchor: "middle",
            size: 12,
            weight: 600
        },   
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/happy_birthday_swirls_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
          
              }
        ],
        user_photo: [{
            id: 'user-photo-1',
            url: 'https://ec-i.s3.eu-west-2.amazonaws.com/placeholders/boy.jpg',
            x: 40,
            y: 40,
            width: 262,
            height: 332,      
            index: 0,    
            text: "Click to Upload Your Photo",
           
         
        }],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,


card_happy_birthday_balloons: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#ffffff",
        "text": [
            {
                "edit": true,
                "value": "HAPPY",
                "x": 170, 
                "y": 210, 
                "font": "IBM Plex Mono",
                "size": 22,
                "color": "#000",
                "anchor": "middle",
                "weight": 600
            },
            {
                "edit": true,
                "value": "BIRTHDAY",
                "x": 170, 
                "y": 235,  
                "font": "IBM Plex Mono",
                "size": 22,
                "color": "#000",
                "anchor": "middle",
                "weight": 600
            },
      
        ],
        name: {
            value: 'Name',
            x: 170,
            y: 245,
            font: 'IBM Plex Mono',
            color: "#000", 
            anchor: "middle",
            size: 22,
            weight: 600
        },   
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/happy_birthday_balloons_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
          
              }
        ],
        user_photo: [],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,



card_i_herd_it_is_your_birthday: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#00A2FF",
        "text": [
            {
                "edit": true,
                "value": "HOPE YOUR DAY IS UDDERLY AMAZING!",
                "x": 170, 
                "y": 455, 
                "font": "IBM Plex Mono",
                "size": 14,
                "color": "#3A406D",
                "anchor": "middle",
                "weight": 600
            }
      
        ],
        name: {
        },   
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/i_herd_it_is_your_birthday_raw.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
          
              }
        ],
        user_photo: [],
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,


card_happy_birthday_yeah: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#fff",
        "text": [
            {
                "edit": true,
                "value": "Wishing You a Very Happy Birthday",
                "x": 170, 
                "y": 440, 
                "font": "Rock Salt",
                "size": 13,
                "color": "#fff",
                "anchor": "middle",
                "weight": 600
            }
      
        ],
        name: {
        },   
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/happy_birthday_yeah_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
          
              }
        ],
        user_photo: [{
            id: 'user-photo-1',
            url: 'https://ec-i.s3.eu-west-2.amazonaws.com/placeholders/boy.jpg',
            x: 40,
            y: 100,
            width: 260,
            height: 280,      
            index: 0,    
            text: "Click to Upload Your Photo",
           
         
        }],
       
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,















//Fathers Day


card_happy_fathers_day: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#1FA9FF",
        "text": [
    
        ],
        name: {
        },   
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/happy_fathers_day_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
          
              }
        ],
        user_photo: [],
       
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,




card_dad_of_the_year_award: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#29496D",
        "text": [
        ],
        name: {
        },   
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/dad_of_the_year_award_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
          
              }
        ],
        user_photo: [{
            id: 'user-photo-1',
            url: 'https://ec-i.s3.eu-west-2.amazonaws.com/placeholders/older-man-grinning.jpg',
            x: 0,
            y: 0,
            width: 340,
            height: 481,      
            index: 0,    
            text: "Click to Upload Your Photo",
           
         
        }],
       
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,



card_best_dad_ever: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#051A37",
        "text": [
         
                {
                    "edit": true,
                    "value": "*",
                    "x": 75, 
                    "y": 440, 
                    "font": "Rock Salt",
                    "size": 13,
                    "color": "#fff",
                    "anchor": "middle",
                    "weight": 600
                }
      ,    
            {
                "edit": true,
                "value": "Pending Fact Check",
                "x": 170, 
                "y": 440, 
                "font": "Rock Salt",
                "size": 13,
                "color": "#fff",
                "anchor": "middle",
                "weight": 600
            }
      
        ],
        name: {
        },   
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/best_dad_ever_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
          
              }
        ],
        user_photo: [],
       
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,



card_worlds_no1_dad: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#243748",
        "text": [
        ],
        name: {
        },   
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/worlds-no1_dad_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
          
              }
        ],
        user_photo: [],
       
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,



card_happy_fathers_day_snaps: {
    front_cover: {
        print_type: "a4_card_portrait",
        ai_background: true,
        user_video: {
                    "url": '', // URL of the user's video
                   "x": 50,
                  "y": 100,
                   "width": 200,
                  "height": 150,
    
               },
      
        type: 'card',
        page_size: page_size['card'],
        frames: getFramesForTheme('default'), 
        background: "#69B9DE",
        "text": [
         
            {
                "edit": true,
                "value": "Your unconditional love inspires me every day",
                "x": 160, 
                "y": 20, 
                "font": "Reenie Beanie",
                "size": 14,
                "color": "#fff",
                "anchor": "middle",
                "weight": 600
            }
  ,    
        {
            "edit": true,
            "value": "From Sarah",
            "x": 170, 
            "y": 440, 
            "font": "Reenie Beanie",
            "size": 18,
            "color": "#fff",
            "anchor": "middle",
            "weight": 600
        }
  
    ],
        name: {
        },   
        image: [
            {
                "id": "imageElement0",
                "url": "https://ec-i.s3.eu-west-2.amazonaws.com/i/happy_fathers_day_snaps_bg.png",
                "x": 0,
                "y": 0,                   
                "r": null,
                "w": 341,
                "h": 481,
                "rotation": 0,
          
              }
        ],
        user_photo: [{
            id: 'user-photo-1',
            url: 'https://ec-i.s3.eu-west-2.amazonaws.com/placeholders/b_w_man_child.jpg',
            x: 70,
            y: 80,
            width: 170,  // Calculated as bottom_right.x - top_left.x
            height: 114, // Calculated as bottom_right.y - top_left.y
            rotation: - 15, // Rotation in degrees
            index: 0,    
            text: "Click to Upload Your Photo",
            style: 'white_photo'
        },
        {
            id: 'user-photo-2',
            url: 'https://ec-i.s3.eu-west-2.amazonaws.com/placeholders/b_w_child.jpg',
            x: 85,
            y: 220,
            width: 150,  // Calculated as bottom_right.x - top_left.x
            height:94, // Calculated as bottom_right.y - top_left.y
            rotation: 20, // Rotation in degrees
            index: 0,    
            text: "Click to Upload Your Photo",
            style: 'white_photo'
        }],
    
       
       
        
        stickers: 'birthday'
    },
    inside_left: {
        
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        stickers: 'birthday', 
        background: '#d2ebea',
        text: {
            value: 'Inner Left Text',
            x: 100,
            y: 230
        }
    },
    inside_right: {
        ai_background: true,
        type: 'card',
        page_size: page_size['card'],
        background: '#d2ebea',
        text: [{
            message_card: true,
            edit: true,
            value: 'Message Card',
            x: 20,
            y: 270,
            font: "Reenie Beanie",
            size: 20,
            color: "#643532",
            anchor: "start",
            maxWidth: 250,
            maxHeight: 200 
        }]
    },
    feature_3d: {
        type: 'card',
        mode: 'card',
        page_size: page_size['card']
    }
}
,

















a4_acrylic_portrait: {
    front_cover: {print_type:"a4_acrylic_portrait",
        type: 'cup',
        page_size: page_size['portait'],
        background: '#f3f3f3',
        frames: [],

        setFrames: function(setName) {
            if (allFrames[setName]) {
                this.frames = allFrames[setName];
            } else {
                console.log("Frame set not found: " + setName);
            }
        }
    ,
    
    user_photo: [{
        id: 'user-photo-1',
        url: 'https://placehold.co/353x500',
        x: 0,
        y: 0,
        width: 353,
        height: 500
    },
    //    

],

},  
},





a5_acrylic_landscape: {
    front_cover: {print_type:"a5_acrylic_landscape",
        type: 'cup',
        page_size: page_size['landscape'],
        background: '#f3f3f3',
        frames: [],

        setFrames: function(setName) {
            if (allFrames[setName]) {
                this.frames = allFrames[setName];
            } else {
                console.log("Frame set not found: " + setName);
            }
        }
    ,
    
    
    user_photo: [{
        id: 'user-photo-1',
        url: 'https://placehold.co/353x250',
        x: 0,
        y: 0,
        width: 353,
        height: 250
    },
    //    

],

},  
},
a5_acrylic_portrait: {
    front_cover: {print_type:"a5_acrylic_portrait",
        type: 'cup',
        page_size: page_size['portait'],
        background: '#f3f3f3',
        frames: [],

        setFrames: function(setName) {
            if (allFrames[setName]) {
                this.frames = allFrames[setName];
            } else {
                console.log("Frame set not found: " + setName);
            }
        }
    ,
    
    
    user_photo: [{
        id: 'user-photo-1',
        url: 'https://placehold.co/353x500',
        x: 0,
        y: 0,
        width: 353,
        height: 500
    },
    //    

],

},  
},
a3_acrylic_landscape: {

    front_cover: {print_type:"a3_acrylic_landscape",
        type: 'acrylic',
        page_size: page_size['landscape'],
        background: '#f3f3f3',
        frames: [],

        
    
    user_photo: [{
        id: 'user-photo-1',
        url: 'https://placehold.co/353x250',
        x: 0,
        y: 0,
        width: 353,
        height: 250
    },
    //    

],


},  
},
a3_acrylic_portrait: {
    front_cover: {print_type:"a3_acrylic_portrait",
        type: 'cup',
        page_size: page_size['portait'],
        background: '#f3f3f3',
        frames: [],

        setFrames: function(setName) {
            if (allFrames[setName]) {
                this.frames = allFrames[setName];
            } else {
                console.log("Frame set not found: " + setName);
            }
        }
    ,
    
    
    user_photo: [{
        id: 'user-photo-1',
        url: 'https://placehold.co/353x500',
        x: 0,
        y: 0,
        width: 353,
        height: 500
    },
    //    

],

},  
},
a4_card_landscape: {
    front_cover: {print_type:"a4_card_landscape",
        type: 'cup',
        page_size: page_size['landscape'],
        background: '#f3f3f3',
        frames: [],

        setFrames: function(setName) {
            if (allFrames[setName]) {
                this.frames = allFrames[setName];
            } else {
                console.log("Frame set not found: " + setName);
            }
        }
    ,
    
    
    user_photo: [{
        id: 'user-photo-1',
        url: 'https://placehold.co/353x250',
        x: 0,
        y: 0,
        width: 353,
        height: 250
    },
    //    

],

},  
},
a4_card_portrait: {
    front_cover: {print_type:"a4_card_portrait",
        type: 'cup',
        page_size: page_size['portait'],
        background: '#f3f3f3',
        frames: [],

        setFrames: function(setName) {
            if (allFrames[setName]) {
                this.frames = allFrames[setName];
            } else {
                console.log("Frame set not found: " + setName);
            }
        }
    ,
    
    
    user_photo: [{
        id: 'user-photo-1',
        url: 'https://placehold.co/353x500',
        x: 0,
        y: 0,
        width: 353,
        height: 500
    },
    //    

],

},  
},
a3_card_landscape: {
    front_cover: {print_type:"a3_card_landscape",
        type: 'cup',
        page_size: page_size['landscape'],
        background: '#f3f3f3',
        frames: [],

        setFrames: function(setName) {
            if (allFrames[setName]) {
                this.frames = allFrames[setName];
            } else {
                console.log("Frame set not found: " + setName);
            }
        }
    ,
    
    
    user_photo: [{
        id: 'user-photo-1',
        url: 'https://placehold.co/353x250',
        x: 0,
        y: 0,
        width: 353,
        height: 250
    },
    //    


],

},  
},
a3_card_portrait: {
    front_cover: {print_type:"a3_card_portrait",
        type: 'cup',
        page_size: page_size['portait'],
        background: '#f3f3f3',
        frames: [],

        setFrames: function(setName) {
            if (allFrames[setName]) {
                this.frames = allFrames[setName];
            } else {
                console.log("Frame set not found: " + setName);
            }
        }
    ,
    
    
    user_photo: [{
        id: 'user-photo-1',
        url: 'https://placehold.co/353x500',
        x: 0,
        y: 0,
        width: 353,
        height: 500
    },
    //    

],

},  
},
a5_card_landscape: {
    front_cover: {print_type:"a5_card_landscape",
        type: 'cup',
        page_size: page_size['landscape'],
        background: '#f3f3f3',
        frames: [],

        setFrames: function(setName) {
            if (allFrames[setName]) {
                this.frames = allFrames[setName];
            } else {
                console.log("Frame set not found: " + setName);
            }
        }
    ,
    
    
    user_photo: [{
        id: 'user-photo-1',
        url: 'https://placehold.co/353x250',
        x: 0,
        y: 0,
        width: 353,
        height: 250
    },
    //    

],

},  
},
a5_card_portrait: {
    front_cover: {print_type:"a5_card_portrait",
        type: 'cup',
        page_size: page_size['portait'],
        background: '#f3f3f3',
        frames: [],

        setFrames: function(setName) {
            if (allFrames[setName]) {
                this.frames = allFrames[setName];
            } else {
                console.log("Frame set not found: " + setName);
            }
        }
    ,
    
    
    user_photo: [{
        id: 'user-photo-1',
        url: 'https://placehold.co/353x500',
        x: 0,
        y: 0,
        width: 353,
        height: 500
    },
    //    

],

},  
},



                            //Full Size
                            a4_acrylic_landscape: {
                                front_cover: {print_type:"a4_acrylic_landscape",
                                    type: 'cup',
                                    page_size: page_size['landscape'],
                                    background: '#f3f3f3',
                                    frames: [],
                            
                                    setFrames: function(setName) {
                                        if (allFrames[setName]) {
                                            this.frames = allFrames[setName];
                                        } else {
                                            console.log("Frame set not found: " + setName);
                                        }
                                    }
                                ,
                                
                                
                                user_photo: [{
                                    id: 'user-photo-1',
                                    url: 'https://placehold.co/353x250',
                                    x: 0,
                                    y: 0,
                                    width: 353,
                                    height: 250
                                },
                                //    
                            
                            ],
                        
                        },  
                        },

    portrait_image: {

        front_cover: {
            type: 'cup',
            page_size: page_size['portait'],
            background: '#f3f3f3',
            frames: [
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/1.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/2.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/3.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/4.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/5.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/6.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/7.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/8.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/9.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/10.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/11.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/12.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/13.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/14.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/15.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/16.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/17.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/18.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/19.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/20.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/21.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/22.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/23.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/24.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/25.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/26.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/27.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/28.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/29.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/30.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/31.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/32.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/33.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/34.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/35.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/36.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/37.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/38.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/39.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/40.png"
            ],
            
            user_photo: [{
                    id: 'user-photo-1',
                    url: 'https://placehold.co/353x500',
                    x: 0,
                    y: 0,
                    width: 353,
                    height: 500
                },
                //    

            ],
         
        },  
    },

    'image_restore_card': {
        // ... your existing configuration for 'image_restore'
        'front_cover': {
            // ...

            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'image_restore'
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
            // ...
        },
        // ...
    },
    'image_old_to_new': {
        // ... your existing configuration for 'image_restore'
        'front_cover': {
            // ...

            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'image_old_to_new'
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
            // ...
        },
        // ...
    },
    'remove_background_card': {
        // ... your existing configuration for 'remove_background'
        'front_cover': {
            // ...
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'remove_background'
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
            // ...
        },
        // ...
    },
    'style_art_card': {
        'front_cover': {
            // ...
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'style_art',
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
            // ...
        },
        // ...
    },
    'style_arcane_multi_card': {
        'front_cover': {
            // ...
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'style_arcane_multi',
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
            // ...
        },
        // ...
    },
    // Add more styles here as needed, following the same pattern
    'style_sketch_multi_card': {
        'front_cover': {
            // ...
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'style_sketch_multi',
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
            // ...
        },
        // ...
    },
    'style_arcane_jinx_card': {
        'front_cover': {
            // ...
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'style_arcane_jinx'
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
            // ...
        },
        // ...
    },
    'style_arcane_caitlyn_card': {
        'front_cover': {
            // ...

            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'style_arcane_caitlyn'
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
            // ...
        },
        // ...
    },
    'style_jojo_yasuho_card': {
        'front_cover': {
            // ...
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'style_jojo_yasuho',
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
            // ...
        },
        // ...
    },
    'style_jojo_card': {
        'front_cover': {
            // ...
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'style_jojo',
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
            // ...
        },
        // ...
    },
    'style_disney_card': {
        'front_cover': {
            // ...
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'style_disney',
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
            // ...
        },
        // ...
    },
    'image_restore_card': {
        'front_cover': {
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'image_restore'
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
        },

        inside_left: {
            type: 'card',

            page_size: page_size['card'],
            user_photo: [{
                    id: 'user-photo-1',
                    url: 'https://placehold.co/100x100',
                    x: 50,
                    y: 50,
                    width: 50,
                    height: 50
                },
                // ... other photos
            ],

            stickers: 'birthday', // or some other valid key from stickerConfigurations

            background: '#6cc0e0', // Set a nice color for the 'inner_left' page
            text: {
                'value': 'Inner Left Text',
                x: 150,
                y: 250,
            }
        },
        inside_right: {
            type: 'card',
            page_size: page_size['card'],

            background: '#4CAF50',
            text: {
                value: 'Message Card',
                x: 250,
                y: 250,
            },
        },
        feature_3d: {
            mode: 'card',
            page_size: page_size['card']
        }
    },
    'Remove Background': {
        'front_cover': {
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'remove_background'
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
        },

        inside_left: {
            type: 'card',

            page_size: page_size['card'],
            user_photo: [{
                    id: 'user-photo-1',
                    url: 'https://placehold.co/100x100',
                    x: 50,
                    y: 50,
                    width: 50,
                    height: 50
                },
                // ... other photos
            ],

            stickers: 'birthday', // or some other valid key from stickerConfigurations

            background: '#6cc0e0', // Set a nice color for the 'inner_left' page
            text: {
                'value': 'Inner Left Text',
                x: 150,
                y: 250,
            }
        },
        inside_right: {
            type: 'card',
            page_size: page_size['card'],

            background: '#4CAF50',
            text: {
                value: 'Message Card',
                x: 250,
                y: 250,
            },
        },
        feature_3d: {
            mode: 'card',
            page_size: page_size['card']
        }
    },
    'Style Transfer': {
        'front_cover': {
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'style_transfer'
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
        },

        inside_left: {
            type: 'card',

            page_size: page_size['card'],
            user_photo: [{
                    id: 'user-photo-1',
                    url: 'https://placehold.co/100x100',
                    x: 50,
                    y: 50,
                    width: 50,
                    height: 50
                },
                // ... other photos
            ],

            stickers: 'birthday', // or some other valid key from stickerConfigurations

            background: '#6cc0e0', // Set a nice color for the 'inner_left' page
            text: {
                'value': 'Inner Left Text',
                x: 150,
                y: 250,
            }
        },
        inside_right: {
            type: 'card',
            page_size: page_size['card'],

            background: '#4CAF50',
            text: {
                value: 'Message Card',
                x: 250,
                y: 250,
            },
        },
        feature_3d: {
            mode: 'card',
            page_size: page_size['card']
        }
    },
    'Realistic Background': {
        'front_cover': {
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            user_photo: [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 250,
                image_transformation: 'realistic_background'
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
        },

        inside_left: {
            type: 'card',

            page_size: page_size['card'],
            user_photo: [{
                    id: 'user-photo-1',
                    url: 'https://placehold.co/100x100',
                    x: 50,
                    y: 50,
                    width: 50,
                    height: 50
                },
                // ... other photos
            ],

            stickers: 'birthday', // or some other valid key from stickerConfigurations

            background: '#6cc0e0', // Set a nice color for the 'inner_left' page
            text: {
                'value': 'Inner Left Text',
                x: 150,
                y: 250,
            }
        },
        inside_right: {
            type: 'card',
            page_size: page_size['card'],

            background: '#4CAF50',
            text: {
                value: 'Message Card',
                x: 250,
                y: 250,
            },
        },
        feature_3d: {
            mode: 'card',
            page_size: page_size['card']
        }
    },
    'Collage Style': {
        'front_cover': {

            'type': 'card',
            page_size: page_size['card'],
            'ai_background': true,
            'background': '#e3e3e3',
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 250,
                font: 'Barrio',
                size: 20
            },
            'user_photo': [{
                    'id': 'user-photo-1',
                    'url': 'https://placehold.co/100x100',
                    'x': 150,
                    'y': 50,
                    'width': 100,
                    'height': 100
                },
                {
                    'id': 'user-photo-2',
                    'url': 'https://placehold.co/100x100',
                    'x': 50,
                    'y': 350,
                    'width': 100,
                    'height': 100
                },
                {
                    'id': 'user-photo-3',
                    'url': 'https://placehold.co/100x100',
                    'x': 150, // Adjusted X coordinate
                    'y': 350, // Adjusted Y coordinate
                    'width': 100,
                    'height': 100
                }
            ],
            'name': {
                'value': 'Your Name',
                'x': 150,
                'y': 450
            },
            'image': {
                'url': 'https://ec-i.s3.eu-west-2.amazonaws.com/birthday-limited-edition.png',
                'x': 150,
                'y': 480,
                'width': 100,
                'height': 100
            },
            'stickers': 'birthday'
        }
    },
    'Diagonal Split': {

        'front_cover': {
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            'user_photo': [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/300x250',
                'x': 0,
                'y': 0,
                'width': 300,
                'height': 450,
                image_transformation: 'image_restore'
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
        }
    },
    'Photo Strip': {

        'front_cover': {
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            'user_photo': [{
                    'id': 'user-photo-1',
                    'url': 'https://placehold.co/100x100',
                    'x': 100,
                    'y': 50,
                    'width': 100,
                    'height': 100
                },
                {
                    'id': 'user-photo-2',
                    'url': 'https://placehold.co/100x100',
                    'x': 100,
                    'y': 200,
                    'width': 100,
                    'height': 100
                },
                {
                    'id': 'user-photo-3',
                    'url': 'https://placehold.co/100x100',
                    'x': 100,
                    'y': 350,
                    'width': 100,
                    'height': 100
                }
            ],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 475
            }
        }
    },
    'Polaroid Style': {

        'front_cover': {
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            'user_photo': [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/200x250',
                'x': 50,
                'y': 100,
                'width': 200,
                'height': 250
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 375
            }
        }
    },
    'Circle Frame': {

        'front_cover': {
            'type': 'card',
            page_size: page_size['card'],
            'background': '#e3e3e3',
            'stickers': 'birthday',
            'user_photo': [{
                'id': 'user-photo-1',
                'url': 'https://placehold.co/200x200',
                'x': 50,
                'y': 150,
                'width': 200,
                'height': 200,
                'shape': 'circle'
            }],
            'text': {
                'value': 'Happy Birthday',
                'x': 150,
                'y': 50
            }
        }
    },

    mug: {

        front_cover: {
            type: 'cup',
            page_size: page_size['mug'],
            background: '#f3f3f3', // Default white mug
            text: {
                value: 'Your Custom Text Here',
                x: 150,
                y: 250,
            },
            image: {
                url: 'https://path-to-your-mug-image-example.png',
                x: 100,
                y: 200,
            },
            stickers: 'birthday', // Default sticker set, can be changed
        }
    },

    tshirt: {

        front_cover: {
            page_size: page_size['mug'],
            background: '#FFFFFF', // Default white t-shirt
            text: {
                value: 'Your Custom Text Here',
                x: 250,
                y: 400,
            },
            image: {
                url: 'https://path-to-your-tshirt-image-example.png',
                x: 250,
                y: 250,
            },
            stickers: 'anniversary', // Default sticker set, can be changed
        },

        back_cover: { // Optional: If you want designs on the back as well
            background: '#FFFFFF',
            text: {
                value: 'Text on the Back',
                x: 250,
                y: 400,
            },
            image: {
                url: 'https://path-to-another-tshirt-image-example.png',
                x: 250,
                y: 250,
            },
            stickers: 'valentines',
        }
    },
    birthday: {

        front_cover: {print_type: "a4_card_portrait", 'ai_background': true,
        //    user_video: {
        //        "url": '', // URL of the user's video
       //         "x": 50,
        ////        "y": 100,
        //        "width": 200,
        //        "height": 150,

        //    },
            type: 'card',
            page_size: page_size['card'],
            ai_background: true,
            frames: [
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/1.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/2.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/3.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/4.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/5.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/6.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/7.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/8.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/9.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/10.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/11.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/12.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/13.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/14.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/15.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/16.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/17.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/18.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/19.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/20.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/21.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/22.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/23.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/24.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/25.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/26.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/27.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/28.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/29.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/30.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/31.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/32.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/33.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/34.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/35.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/36.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/37.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/38.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/39.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/40.png"
            ],
              background: '#87CEEB',
            text: {
                value: 'Happy Birthday',
                x: 65,
                y: 70,
                font: 'Barrio',
                size: 30
            },
            user_photo: [{
                    id: 'user-photo-1',
                    url: 'https://placehold.co/150x150',
                    x: 100,
                    y: 130,
                    width: 150,
                    height: 150
                },
                //     {id: 'user-photo-2', url: 'https://placehold.co/100x100', x: 350, y: 50, width: 150, height: 150}

            ],

            name: {
                value: 'Your Name',
                x: 120,
                y: 400,
                font: 'Rubik Dirt',
                size: 20
            },
            image: {
                url: 'https://ec-i.s3.eu-west-2.amazonaws.com/balloons_transparent.png', // Replace with the correct URL
                x: 170,
                y: 350,
            },
        //    stickers: 'birthday',


        },

        inside_left: {print_type: "a4_card_portrait", 'ai_background': true,
            type: 'card',

            page_size: page_size['card'],
           
            stickers: 'birthday', // or some other valid key from stickerConfigurations

            background: '#6cc0e0', // Set a nice color for the 'inner_left' page
            text: {
                'value': 'Inner Left Text',
                x: 100,
                y: 230,
            }
        },
        inside_right: {
            type: 'card',
            page_size: page_size['card'],

            background: '#4CAF50',
            text: {
                value: 'Message Card',
                x: 100,
                y: 230,
            },
        },
        feature_3d: {
            type: 'card',
            mode: 'card',
            page_size: page_size['card']
        }
    },
    card_bestie: {

        front_cover: {print_type: "a4_card_portrait", 'ai_background': true,
        //    user_video: {
        //        "url": '', // URL of the user's video
       //         "x": 50,
        ////        "y": 100,
        //        "width": 200,
        //        "height": 150,

        //    },
            type: 'card',
            page_size: page_size['card'],
            ai_background: true,
            frames: [
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/1.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/2.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/3.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/4.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/5.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/6.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/7.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/8.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/9.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/10.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/11.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/12.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/13.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/14.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/15.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/16.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/17.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/18.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/19.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/20.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/21.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/22.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/23.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/24.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/25.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/26.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/27.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/28.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/29.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/30.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/31.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/32.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/33.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/34.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/35.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/36.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/37.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/38.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/39.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/40.png"
            ],
              background: '#d2ebea',
           
              text:[
                {
                    "edit": false,
                    "value": "Happy Birthday",
                    "x": 170, // Centered on the card width
                    "y": 330, // Adjusted for positioning near the bottom
                    "font": "Amatic SC",
                    "size": 45,
                    "color": "#643532",
                    "anchor": "middle",
                    "weight": 500
                  },
                  {
                    "edit": false,
                    "value": "My",
                    "x": 170, // Centered on the card width
                    "y": 375, // Adjusted for positioning near the bottom
                    "font": "Amatic SC",
                    "size": 38,
                    "color": "#643532",
                    "anchor": "middle",
                    "weight": 500
                  },
                  {
                    "edit": false,
                    "value": "BEST-TEA!",
                    "x": 170, // Centered on the card width
                    "y": 420, // Adjusted for positioning near the bottom
                    "font": "Amatic SC",
                    "size": 38,
                    "color": "#643532",
                    "anchor": "middle",
                    "weight": 500
                  }
              ],

           // name: {
            //    value: 'Enter Name',
          ////      x: 100,
          //      y: 40,
          //      font: 'Hachi Maru Pop',
           //     size: 20
          //  },
            image: [
                {
                  url: 'https://ec-i.s3.eu-west-2.amazonaws.com/cups+and+balloons.png', // First image URL
                  "y": 40, 
                  "x": 45,
                
                  "w": 250, 
                  "h": 250,
                  "r": 0 
                }
         
              ]
,              
          stickers: 'birthday',


        },

        inside_left: {print_type: "a4_card_portrait", 'ai_background': true,
            type: 'card',

            page_size: page_size['card'],
           
            stickers: 'birthday', // or some other valid key from stickerConfigurations

            background: '#d2ebea',
            text: {
                'value': 'Inner Left Text',
                x: 100,
                y: 230,
            }
        },
        inside_right: { 'ai_background': true,
            type: 'card',
            page_size: page_size['card'],

            background: '#d2ebea',
            text: [{
                "edit": true,
                value: 'Message Card',
                x: 70,
                y: 230,
                "font": "Reenie Beanie",
                "size": 38,
                "color": "#643532",
                "anchor": "start"
            }],
        },
        feature_3d: {
            type: 'card',
            mode: 'card',
            page_size: page_size['card']
        }
    },
    
   
    




    birthday_a5: {

        front_cover: {print_type: "a5_card_portrait",
        //    user_video: {
        //        "url": '', // URL of the user's video
       //         "x": 50,
        ////        "y": 100,
        //        "width": 200,
        //        "height": 150,

        //    },
            type: 'card',
            page_size: page_size['card'],
            ai_background: true,
            frames: [
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/1.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/2.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/3.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/4.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/5.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/6.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/7.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/8.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/9.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/10.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/11.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/12.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/13.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/14.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/15.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/16.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/17.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/18.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/19.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/20.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/21.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/22.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/23.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/24.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/25.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/26.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/27.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/28.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/29.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/30.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/31.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/32.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/33.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/34.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/35.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/36.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/37.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/38.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/39.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/40.png"
            ],
              background: '#87CEEB',
            text: {
                value: 'Happy Birthday',edit:false,
                x: 65,
                y: 70,
                font: 'Barrio',
                size: 30
            },
            user_photo: [{
                    id: 'user-photo-1',
                    url: 'https://placehold.co/150x150',
                    x: 100,
                    y: 130,
                    width: 150,
                    height: 150
                },
                //     {id: 'user-photo-2', url: 'https://placehold.co/100x100', x: 350, y: 50, width: 150, height: 150}

            ],

            name: {
                value: 'Your Name',
                x: 120,
                y: 400,
                font: 'Rubik Dirt',
                size: 20
            },
            image: {
                url: 'https://ec-i.s3.eu-west-2.amazonaws.com/balloons_transparent.png', // Replace with the correct URL
                x: 170,
                y: 350,
            },
        //    stickers: 'birthday',


        },

        inside_left: {print_type: "a5_card_portrait",
            type: 'card',

            page_size: page_size['card'],
           
            stickers: 'birthday', // or some other valid key from stickerConfigurations

            background: '#6cc0e0', // Set a nice color for the 'inner_left' page
            text: {
                'value': 'Inner Left Text',
                x: 100,
                y: 230,
            }
        },
        inside_right: {print_type: "a5_card_portrait",
            type: 'card',
            page_size: page_size['card'],

            background: '#4CAF50',
            text: {
                value: 'Message Card',
                x: 100,
                y: 230,
            },
        },
        feature_3d: {
            mode: 'card',
            page_size: page_size['card']
        }
    },

    birthday_a4: {

        front_cover: {print_type: "a4_card_portrait",
        //    user_video: {
        //        "url": '', // URL of the user's video
       //         "x": 50,
        ////        "y": 100,
        //        "width": 200,
        //        "height": 150,

        //    },
            type: 'card',
            page_size: page_size['card'],
            ai_background: true,
            frames: [
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/1.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/2.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/3.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/4.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/5.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/6.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/7.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/8.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/9.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/10.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/11.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/12.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/13.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/14.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/15.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/16.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/17.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/18.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/19.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/20.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/21.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/22.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/23.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/24.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/25.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/26.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/27.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/28.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/29.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/30.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/31.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/32.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/33.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/34.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/35.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/36.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/37.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/38.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/39.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/40.png"
            ],
              background: '#87CEEB',
            text: {
                value: 'Happy Birthday',
                x: 65,
                y: 70,
                font: 'Barrio',
                size: 30
            },
            user_photo: [{
                    id: 'user-photo-1',
                    url: 'https://placehold.co/150x150',
                    x: 100,
                    y: 130,
                    width: 150,
                    height: 150
                },
                //     {id: 'user-photo-2', url: 'https://placehold.co/100x100', x: 350, y: 50, width: 150, height: 150}

            ],

            name: {
                value: 'Your Name',
                x: 120,
                y: 400,
                font: 'Rubik Dirt',
                size: 20
            },
            image: {
                url: 'https://ec-i.s3.eu-west-2.amazonaws.com/balloons_transparent.png', // Replace with the correct URL
                x: 170,
                y: 350,
            },
        //    stickers: 'birthday',


        },

        inside_left: {print_type: "a4_card_portrait",
            type: 'card',

            page_size: page_size['card'],
           
            stickers: 'birthday', // or some other valid key from stickerConfigurations

            background: '#6cc0e0', // Set a nice color for the 'inner_left' page
            text: {
                'value': 'Inner Left Text',
                x: 100,
                y: 230,
            }
        },
        inside_right: {print_type: "a4_card_portrait",
            type: 'card',
            page_size: page_size['card'],

            background: '#4CAF50',
            text: {
                value: 'Message Card',
                x: 100,
                y: 230,
            },
        },
        feature_3d: {
            mode: 'card',
            page_size: page_size['card']
        }
    },


    birthday_a3: {

        front_cover: {print_type: "a3_card_portrait",
        //    user_video: {
        //        "url": '', // URL of the user's video
       //         "x": 50,
        ////        "y": 100,
        //        "width": 200,
        //        "height": 150,

        //    },
            type: 'card',
            page_size: page_size['card'],
            ai_background: true,
            frames: [
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/1.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/2.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/3.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/4.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/5.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/6.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/7.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/8.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/9.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/10.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/11.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/12.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/13.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/14.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/15.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/16.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/17.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/18.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/19.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/20.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/21.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/22.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/23.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/24.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/25.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/26.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/27.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/28.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/29.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/30.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/31.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/32.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/33.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/34.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/35.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/36.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/37.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/38.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/39.png",
                "https://ec-i.s3.eu-west-2.amazonaws.com/frames/40.png"
            ],
              background: '#87CEEB',
            text: {
                value: 'Happy Birthday',
                x: 65,
                y: 70,
                font: 'Barrio',
                size: 30
            },
            user_photo: [{
                    id: 'user-photo-1',
                    url: 'https://placehold.co/150x150',
                    x: 100,
                    y: 130,
                    width: 150,
                    height: 150
                },
                //     {id: 'user-photo-2', url: 'https://placehold.co/100x100', x: 350, y: 50, width: 150, height: 150}

            ],

            name: {
                value: 'Your Name',
                x: 120,
                y: 400,
                font: 'Rubik Dirt',
                size: 20
            },
            image: {
                url: 'https://ec-i.s3.eu-west-2.amazonaws.com/balloons_transparent.png', // Replace with the correct URL
                x: 170,
                y: 350,
            },
        //    stickers: 'birthday',


        },

        inside_left: {print_type: "a3_card_portrait",
            type: 'card',

            page_size: page_size['card'],
           
            stickers: 'birthday', // or some other valid key from stickerConfigurations

            background: '#6cc0e0', // Set a nice color for the 'inner_left' page
            text: {
                'value': 'Inner Left Text',
                x: 100,
                y: 230,
            }
        },
        inside_right: {print_type: "a3_card_portrait",
            type: 'card',
            page_size: page_size['card'],

            background: '#4CAF50',
            text: {
                value: 'Message Card',
                x: 100,
                y: 230,
            },
        },
        feature_3d: {
            mode: 'card',
            page_size: page_size['card']
        }
    },





    
    valentines: {
        front_cover: {
            type: 'card',
            page_size: page_size['card'],
            background: '#FFC0CB',
            text: {
                value: 'Happy Valentine\'s Day!',
                x: 250,
                y: 150,
            },
            user_photo: single_photo,
            name: {
                value: 'To My Special Someone',
                x: 250,
                y: 400,
            },
            image: {
                url: 'valentine-special-edition.png',
                x: 150,
                y: 250,
            },
            stickers: 'valentines',
        },
        inside_left: {
            type: 'card',
            page_size: page_size['card'],

            stickers: 'valentines',
            background: '#FFE4E1',
            text: {
                value: 'You mean the world to me.',
                x: 150,
                y: 250,
            }
        },
        inside_right: {
            type: 'card',
            page_size: page_size['card'],
            background: '#FFD1DC',
            text: {
                value: 'Forever Yours',
                x: 250,
                y: 250,
            },
        },
    },
    christmas: {
        type: 'card',
        page_size: page_size['card'],
        front_cover: {
            background: '#FF0000',
            text: {
                value: 'Merry Christmas!',
                x: 250,
                y: 150,
            },
            name: {
                value: 'Seasons Greetings',
                x: 250,
                y: 400,
            },
            image: {
                url: 'christmas-special-edition.png',
                x: 150,
                y: 250,
            },
            stickers: 'christmas',
        },
        inside_left: {
            type: 'card',
            page_size: page_size['card'],
            stickers: 'christmas',
            background: '#008000',
            text: {
                value: 'Wishing you joy and peace.',
                x: 150,
                y: 250,
            }
        },
        inside_right: {
            type: 'card',
            page_size: page_size['card'],
            background: '#FFFAF0',
            text: {
                value: 'Happy Holidays!',
                x: 250,
                y: 250,
            },
        },
    },
    new_year: {
        front_cover: {
            background: '#000080',
            text: {
                value: 'Happy New Year 2024!',
                x: 250,
                y: 150,
            },
            name: {
                value: 'Cheers to New Beginnings',
                x: 250,
                y: 400,
            },
            image: {
                url: 'newyear-special-edition.png',
                x: 150,
                y: 250,
            },
            stickers: 'new_year',
        },
        inside_left: {
            stickers: 'new_year',
            background: '#D3D3D3',
            text: {
                value: 'New dreams, new hopes!',
                x: 150,
                y: 250,
            }
        },
        inside_right: {
            background: '#B0E0E6',
            text: {
                value: 'Wishing you success and happiness!',
                x: 250,
                y: 250,
            },
        },
    },
    halloween: {
        front_cover: {
            background: '#FF8C00',
            text: {
                value: 'Happy Halloween!',
                x: 250,
                y: 150,
            },
            name: {
                value: 'Trick or Treat?',
                x: 250,
                y: 400,
            },
            image: {
                url: 'halloween-special-edition.png',
                x: 150,
                y: 250,
            },
            stickers: 'halloween',
        },
        inside_left: {
            stickers: 'halloween',
            background: '#4B0082',
            text: {
                value: 'Stay spooky!',
                x: 150,
                y: 250,
            }
        },
        inside_right: {
            background: '#FA8072',
            text: {
                value: 'Boo!',
                x: 250,
                y: 250,
            },
        },
    },
    anniversary: {
        front_cover: {
            background: '#FFD700',
            text: {
                value: 'Happy Anniversary!',
                x: 250,
                y: 150,
            },
            name: {
                value: 'To Us',
                x: 250,
                y: 400,
            },
            image: {
                url: 'anniversary-special-edition.png',
                x: 150,
                y: 250,
            },
            stickers: 'anniversary',
        },
        inside_left: {
            stickers: 'anniversary',
            background: '#FF6347',
            text: {
                value: 'To many more years together.',
                x: 150,
                y: 250,
            }
        },
        inside_right: {
            background: '#FFB6C1',
            text: {
                value: 'With love and joy!',
                x: 250,
                y: 250,
            },
        },
    },
    easter: {
        front_cover: {
            background: '#98FB98',
            text: {
                value: 'Happy Easter!',
                x: 250,
                y: 150,
            },
            name: {
                value: 'Springtime Blessings',
                x: 250,
                y: 400,
            },
            image: {
                url: 'easter-special-edition.png',
                x: 150,
                y: 250,
            },
            stickers: 'easter',
        },
        inside_left: {
            stickers: 'easter',
            background: '#FFDAB9',
            text: {
                value: 'Rejoice and be glad!',
                x: 150,
                y: 250,
            }
        },
        inside_right: {
            background: '#EE82EE',
            text: {
                value: 'Easter blessings to you.',
                x: 250,
                y: 250,
            },
        },
    }
}